export default {
  title: 'Din udbyder håndterer dette trin',
  description: {
    payments: 'Kontakt {{partner}} for at opsætte onlinebetalinger.',
    go_live: 'Kontakt {{partner}} for at få din restaurant live.',
  },
  fallback_partner: 'din udbyder',
};
